// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_timeline_item_type_enum */
var FermentationTimelineItemTypeEnum;
(function (FermentationTimelineItemTypeEnum) {
    FermentationTimelineItemTypeEnum["SAMPLE"] = "SAMPLE";
    FermentationTimelineItemTypeEnum["HARVEST"] = "HARVEST";
    FermentationTimelineItemTypeEnum["ADDITION_CHANGE"] = "ADDITION_CHANGE";
    FermentationTimelineItemTypeEnum["PHASE_CHANGE"] = "PHASE_CHANGE";
    FermentationTimelineItemTypeEnum["INOCULATION"] = "INOCULATION";
    FermentationTimelineItemTypeEnum["REMINDER"] = "REMINDER";
    FermentationTimelineItemTypeEnum["MAINTENANCE"] = "MAINTENANCE";
    FermentationTimelineItemTypeEnum["MEASUREMENT"] = "MEASUREMENT";
    FermentationTimelineItemTypeEnum["CUSTOM"] = "CUSTOM";
})(FermentationTimelineItemTypeEnum || (FermentationTimelineItemTypeEnum = {}));
;
export default FermentationTimelineItemTypeEnum;
/** Zod schema for fermentation_timeline_item_type_enum */
export const fermentationTimelineItemTypeEnum = z.nativeEnum(FermentationTimelineItemTypeEnum);
//# sourceMappingURL=FermentationTimelineItemTypeEnum.js.map